import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const ExtensionSubMenu = () => {
  const router = useRouter();
  const resourcesRouteStartUrl = '/resources/';
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-second-level-selected-menu::before': { bottom: -10 },
        }}
      >
        <CustomButton
          href="/business-tax/"
          text="Business Tax<br />Forms"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/business-icon-app.png"
              alt="Extension Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/tax-extension'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          className={getSubMenuHoverClassName(
            'btn-businesstax-supported-forms'
          )}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          {/* <Button
            aria-haspopup="true"
            id="btn-businesstax-supported-forms"
            onClick={() =>
              toggleSelectedSubMenu('btn-businesstax-supported-forms')
            }
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/business-tax/efile-irs-form-1120-s',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 180, '&:before': { left: 50 } }}
          >
            <Box component={'ul'}>
              <li>
                <Link href="/business-tax/efile-irs-form-1120-s/">
                  Form 1120-S
                </Link>
              </li>
            </Box>
          </Box> */}
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-business-tax-form')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-business-tax-form"
            onClick={() => toggleSelectedSubMenu('btn-business-tax-form')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus &:active': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/business-tax/efile-irs-form-1120-s',
              '/business-tax/efile-irs-form-1065-online',
              '/business-tax/efile-irs-form-1120',
              '/business-tax/efile-california-form-100s',
              '/business-tax/efile-california-form-565',
              '/business-tax/efile-california-form-568',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,
              left: '-40px !important',
              '&:before': { left: 70 },
            }}
          >
            <Box component="ul">
              <li>
                <Link
                  href="/business-tax/efile-irs-form-1120-s/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Form 1120-S
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/efile-irs-form-1065-online/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover': { color: '#0202ff' },
                  }}
                >
                  Form 1065
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/efile-irs-form-1120/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Form 1120
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/efile-california-form-100s/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover': { color: '#0202ff' },
                  }}
                >
                  CA FTB - Form 100S
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/efile-california-form-565/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover': { color: '#0202ff' },
                  }}
                >
                  CA FTB - Form 565
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/efile-california-form-568/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover': { color: '#0202ff' },
                  }}
                >
                  CA FTB - Form 568
                </Link>
              </li>
            </Box>
          </Box>
        </Box>

        <Box
          className={getSubMenuHoverClassName('btn-business-tax-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-business-tax-instructions"
            // href="/resources/business-tax/form-1120-s-instructions/"
            onClick={() =>
              toggleSelectedSubMenu('btn-business-tax-instructions')
            }
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Instructions
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 200,
              left: 'auto !important',
              right: 0,
              '&:before': { right: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/business-tax/form-1120-s-instructions/">
                  Form 1120-S Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/business-tax/form-1065-instructions/">
                  Form 1065 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/business-tax/form-100s-instructions/">
                  Form 100S Instructions
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-businesstax-due-dates')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-businesstax-due-dates"
            // href="/resources/business-tax/form-1120-s-filing-deadlines-and-penalties-guide/"
            onClick={() => toggleSelectedSubMenu('btn-businesstax-due-dates')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Due Dates
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 200,
              left: 'auto !important',
              right: 0,
              '&:before': { right: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/business-tax/form-1120-s-filing-deadlines-and-penalties-guide/">
                  Form 1120-S Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/business-tax/form-1065-filing-deadlines-and-penalties-guide/">
                  Form 1065 Due Dates
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-extension-due-dates')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-extension-due-dates"
            onClick={() => toggleSelectedSubMenu('btn-extension-due-dates')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Resources
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { sm: 780, md: 770, lg: 930 },
              pt: '0 !important',
              left: {
                lg: '-708px !important',
                md: '-561px !important',
                sm: '-586px !important',
              },
              '&:before': { left: { lg: 744, md: 608, sm: 617 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Grid
                container
                spacing={2}
                m={0}
                className="MuiGrid-root-width"
                sx={{ justifyContent: 'center', px: 2 }}
              >
                <Grid size={{ xs: 12, sm: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      mb: 0,
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 87, xl: 86 },
                      },
                      '& > a:hover': {
                        color: '#8f72c5 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#43247b !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1120-s/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 14, xl: 14 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            S Corporation
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            These Schedules and Resources help you to file Form
                            1120-S.
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={1}
                    m={0}
                    sx={{
                      pt: '0 !important',
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120-s-mailing-address/`}
                      >
                        Mailing Address
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-k-1/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        Schedule K-1
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120s-schedule-d/`}
                      >
                        Schedule D
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-b/`}
                      >
                        Schedule B
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-m3-form-1120s/`}
                      >
                        Schedule M-3
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-k/`}
                      >
                        Schedule K
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-l/`}
                      >
                        Schedule L
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-m-1/`}
                      >
                        Schedule M-1
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-m-2/`}
                      >
                        Schedule M‑2
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-k-vs-schedule-k-1/`}
                      >
                        Schedule K vs Schedule K-1
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-l/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 1120-S vs Form 1120
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120-s-separately-stated-income-items-of-an-s-corporation/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Separated Stated Income Items
                      </Button>

                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120-s-separately-vs-nonseparately-stated-items/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Separately vs Nonseparately Stated Items
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120-s-stock-and-debt-basis/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Stock and Debt Basis
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 0.2 }}
                  sx={{ mt: 1, mb: 0, borderRight: '1px solid #dedede' }}
                />
                <Grid size={{ xs: 12, sm: 3.7 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      mb: 0,
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 87, xl: 86 },
                      },
                      '& > a:hover': {
                        color: '#8f72c5 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#43247b !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/efile-irs-form-1065-online/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 14, xl: 14 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            Partnership
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            These Schedules and Resources help you to file Form
                            1065.
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={2}
                    m={0}
                    sx={{
                      pt: '0 !important',
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 12 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1065-mailing-address/`}
                      >
                        Mailing Address
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-k1-1065/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        Schedule K-1
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-m-3-form-1065/`}
                      >
                        Schedule M-3
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-m-1-form-1065/`}
                      >
                        Schedule M-1
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-b-2-form-1065-instruction/`}
                      >
                        Schedule B-1
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/schedule-b-2-form-1065-instruction/`}
                      >
                        Schedule B-2
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 0.2 }}
                  sx={{ mt: 1, mb: 0, borderRight: '1px solid #dedede' }}
                />
                <Grid size={{ xs: 12, sm: 3.7 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      mb: 0,
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 87, xl: 86 },
                      },
                      '& > a:hover': {
                        color: '#8f72c5 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#43247b !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}business-tax/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 15, xl: 14 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            Related Forms & Resources
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            Supporting forms and resources to help you to file
                            accurately.
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={2}
                    m={0}
                    sx={{
                      pt: '0 !important',
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#43247b !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 12 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1125-a/`}
                      >
                        Form 1125-A
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1125-e/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        Form 1125-E
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-8825/`}
                      >
                        Form 8825
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-4562/`}
                      >
                        Form 4562
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-4797/`}
                      >
                        Form 4797
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-7205/`}
                      >
                        Form 7205
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}business-tax/form-1120s-vs-form-1065-comparison/`}
                      >
                        Form 1120-S vs Form 1065
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        <Box
          className={getSubMenuHoverClassName('btn-business-tax-state')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-business-tax-state"
            onClick={() => toggleSelectedSubMenu('btn-business-tax-state')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus &:active': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName(['/business-tax/state-filing'])}
          >
            State Filing
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,
              left: '-40px !important',
              '&:before': { left: 70 },
            }}
          >
            <Box component="ul">
              <li>
                <Link
                  href="/business-tax/state-filing/alabama-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Alabama (AL)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/arizona-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Arizona (AZ)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/arkansas-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Arkansas (AR)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/california-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  California (CA)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/colorado-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Colorado (CO)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/connecticut-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Connecticut (CT)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/delaware-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Delaware (DE)
                </Link>
              </li>
              <li>
                <Link
                  href="/business-tax/state-filing/florida-tax-filing-requirements/"
                  sx={{
                    textDecoration: 'none',
                    color: '#333',
                    '&:hover &': { color: '#0202ff' },
                  }}
                >
                  Florida (FL)
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ExtensionSubMenu;
